import * as TypeGraphQL from "type-graphql";
export var SyncEventScalarFieldEnum;
(function (SyncEventScalarFieldEnum) {
    SyncEventScalarFieldEnum["id"] = "id";
    SyncEventScalarFieldEnum["timestamp"] = "timestamp";
    SyncEventScalarFieldEnum["type"] = "type";
    SyncEventScalarFieldEnum["direction"] = "direction";
    SyncEventScalarFieldEnum["entityType"] = "entityType";
    SyncEventScalarFieldEnum["entityId"] = "entityId";
    SyncEventScalarFieldEnum["duration"] = "duration";
    SyncEventScalarFieldEnum["success"] = "success";
    SyncEventScalarFieldEnum["error"] = "error";
    SyncEventScalarFieldEnum["metadata"] = "metadata";
})(SyncEventScalarFieldEnum || (SyncEventScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(SyncEventScalarFieldEnum, {
    name: "SyncEventScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=SyncEventScalarFieldEnum.js.map